import React from 'react';

const NewAttendeeModal = () => {
	return (
		<></>
	);
};

export default NewAttendeeModal;
